var map = {
	"./#03CEA4/Weekdays.svg": "a5d9",
	"./#3777FF/Weekdays.svg": "9b94",
	"./#EE964B/Weekdays.svg": "0b2a",
	"./#F754A2/Weekdays.svg": "5b49",
	"./#FF495C/Weekdays.svg": "602d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2c6";